import React from 'react';
import { Input, FormControl, InputAdornment, makeStyles } from '@material-ui/core';
import { useDispatch } from 'react-redux';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faSearch } from '@fortawesome/free-solid-svg-icons';
import { setSearchString } from '../../slices/RiskFilterSlice';
import { SearchTextCard } from './RunFilterStyle';
import { pushCheckBoxShowLoading } from '../../slices/SpinnerSlice';
import { withRouter } from 'react-router-dom';
import { getRiskAPIResponseData } from '../../services/apiservices';
const useStyles = makeStyles({
  formRoot: {
    width: '100%'
  },
  input: {
    background: 'rgba(228,230,236,0.4)',
    padding: '0px 8px',
    height: '28px',
    '&:before': {
      borderBottom: 'none !important'
    }
  },
  inputSearchIcon: {
    color: '#3E3E3C'
  }
});

const CardHeader = ({
  type,
  searchRowsPerPage,
  searchUpdatedpage,
  match
}) => {
  const classes = useStyles();
  const dispatch = useDispatch();
  let timer = '';
  return /*#__PURE__*/React.createElement(SearchTextCard, null, /*#__PURE__*/React.createElement(FormControl, {
    className: classes.formRoot
  }, /*#__PURE__*/React.createElement(Input, {
    className: classes.input,
    disableUnderline: false,
    id: "input-with-icon-adornment",
    placeholder: "Search",
    startAdornment: /*#__PURE__*/React.createElement(InputAdornment, {
      position: "start",
      className: classes.inputSearchIcon
    }, /*#__PURE__*/React.createElement(FontAwesomeIcon, {
      icon: faSearch
    })),
    onChange: event => {
      dispatch(setSearchString(event.target.value));
      let searchString = event.target.value;

      if (searchString.length > 0) {
        dispatch(pushCheckBoxShowLoading(true));
      } else {
        dispatch(pushCheckBoxShowLoading(false));
      }

      clearTimeout(timer);
      let entityKeyName = type && type.keyName;
      let searchType = entityKeyName === 'Application Name' ? 'appName' : entityKeyName === 'Application Type' ? 'appType' : entityKeyName === 'Environment Name' ? 'envName' : entityKeyName === 'Entity Type' ? 'objectType' : entityKeyName === 'Entity Name' ? 'objectName' : null;
      let filterValue = ['recoType=any'];
      let url = '/api/reco/criteria';
      timer = setTimeout(() => {
        if (searchString.length > 0) {
          filterValue.push(`${searchType}:c:${searchString}`);

          if (!match.params.appName) {
            url += `?fieldList=${searchType}&filter=${filterValue.join(',')}`;
          } else if (match.params.appName && match.params.appName.length > 0 && !match.params.envName) {
            filterValue = [...filterValue, `origin=${match.params.appName}`];
            url += `?fieldList=${searchType}&filter=${filterValue.join(',')}`;
          } else if (match.params.envName && match.params.envName.length > 0) {
            filterValue = [...filterValue, `origin=${match.params.appName}`, `envName=${match.params.envName}`];
            url += `?fieldList=${searchType}&filter=${filterValue.join(',')}`;
          }

          url += `&limit=${searchRowsPerPage}&offset=${searchUpdatedpage}`;
          dispatch(getRiskAPIResponseData(url, 'search'));
        }
      }, 1000);
    }
  })));
};

export default withRouter(CardHeader);